/*
 * My Dental Products: "Maak je routine compleet" add-ons on the RC product page.
 * - Keeps the checked add-ons per product form, also when the theme re-renders the product info on variant change.
 * - Shows the live total in the buy button: [data-mdp-atc-total] (main variant price x quantity + checked add-ons).
 * - When at least one add-on is checked, the product form submit (and the sticky bar submit) is replaced by ONE
 *   POST /cart/add.js with an items array [main variant, ...add-ons]. Selling plan and line item properties of
 *   the main form are kept. Afterwards the custom cart drawer (assets/mdp-cart-drawer.js, window.MDPCart) syncs
 *   gifts, re-renders and opens. Without checked add-ons nothing changes: the theme handles the submit as before.
 */
(function () {
  if (window.__mdpRoutineAddons) return;
  window.__mdpRoutineAddons = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var state = {};

  function st(formId) {
    if (!state[formId]) state[formId] = { checked: {}, variant: null, variants: null };
    return state[formId];
  }

  function getForm(formId) {
    return document.getElementById(formId) || document.forms[formId] || null;
  }

  /* ---------------- Money ---------------- */

  function moneyFormat() {
    var s = window.themeVariables && window.themeVariables.settings;
    return (s && s.moneyFormat) || '€{{amount_with_comma_separator}}';
  }

  function formatMoney(cents) {
    var format = String(moneyFormat()).replace(/<[^>]*>/g, '');
    cents = Math.round(Number(cents) || 0);
    function withDelimiters(number, precision, thousands, decimal) {
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount': return withDelimiters(cents, 2, ',', '.');
        case 'amount_no_decimals': return withDelimiters(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(cents, 2, "'", '.');
        case 'amount_with_space_separator': return withDelimiters(cents, 2, ' ', ',');
        default: return withDelimiters(cents, 2, '.', ',');
      }
    });
  }

  /* ---------------- Reading the page ---------------- */

  function addonElements(formId) {
    return document.querySelectorAll('mdp-routine-addons[form-id="' + formId + '"]');
  }

  function checkedAddons(formId) {
    var seen = {};
    var list = [];
    var els = addonElements(formId);
    for (var i = 0; i < els.length; i++) {
      var boxes = els[i].querySelectorAll('[data-mdp-ra-check]:checked');
      for (var j = 0; j < boxes.length; j++) {
        var id = Number(boxes[j].value);
        if (!id || seen[id]) continue;
        seen[id] = true;
        list.push({ id: id, price: Number(boxes[j].getAttribute('data-price')) || 0 });
      }
    }
    return list;
  }

  function fieldValue(form, name) {
    if (!form || !form.elements) return '';
    var el = form.elements[name];
    if (!el) return '';
    if (typeof el.value === 'string' && el.value !== '') return el.value;
    if (el.length && el[0] && typeof el[0].value === 'string') return el[0].value;
    return '';
  }

  function quantity(form) {
    var q = parseInt(fieldValue(form, 'quantity'), 10);
    return q > 0 ? q : 1;
  }

  /* ---------------- Total in the buy button ---------------- */

  function update(formId) {
    var s = st(formId);
    var spans = document.querySelectorAll('[data-mdp-atc-total][data-form="' + formId + '"]');
    if (!spans.length) return;
    var v = currentVariant(formId);
    var text = '';
    if (v && v.available !== false && typeof v.price === 'number') {
      var total = v.price * quantity(getForm(formId));
      checkedAddons(formId).forEach(function (a) { total += a.price; });
      text = ' · ' + formatMoney(total);
    }
    for (var i = 0; i < spans.length; i++) {
      if (spans[i].textContent !== text) spans[i].textContent = text;
    }
  }

  /* The selected variant is whatever the product form will submit: its [name=id] value, looked up in the
     variant price map rendered by the snippet. Falls back to the last variant:change detail. */
  function currentVariant(formId) {
    var s = st(formId);
    var form = getForm(formId);
    var id = String(fieldValue(form, 'id') || '');
    if (!id) {
      try {
        id = new URLSearchParams(window.location.search).get('variant') || '';
      } catch (e) {
        id = '';
      }
    }
    if (s.variants && id && s.variants[id]) {
      var m = s.variants[id];
      return { id: Number(id), price: Number(m.price), available: m.available !== false };
    }
    return s.variant;
  }

  function readVariants(el, s) {
    var json = el.querySelector('[data-mdp-ra-variants]');
    if (!json) return;
    try {
      s.variants = JSON.parse(json.textContent);
    } catch (e) {
      /* keep the previous map */
    }
  }

  function updateAll() {
    Object.keys(state).forEach(update);
  }

  var scheduled = false;
  function scheduleUpdateAll() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || setTimeout)(function () {
      scheduled = false;
      updateAll();
    });
  }

  /* ---------------- Custom element ---------------- */

  class RoutineAddons extends HTMLElement {
    connectedCallback() {
      var el = this;
      var formId = el.getAttribute('form-id');
      if (!formId) return;
      var s = st(formId);

      readVariants(el, s);
      if (!s.variant) {
        s.variant = {
          id: Number(el.getAttribute('data-variant-id')),
          price: Number(el.getAttribute('data-variant-price')),
          available: el.getAttribute('data-variant-available') !== 'false'
        };
      }

      /* Restore the choices after a re-render of the product info. */
      var boxes = el.querySelectorAll('[data-mdp-ra-check]');
      for (var i = 0; i < boxes.length; i++) boxes[i].checked = !!s.checked[boxes[i].value];

      if (!el.__mdpBound) {
        el.__mdpBound = true;
        el.addEventListener('change', function (event) {
          var box = event.target.closest && event.target.closest('[data-mdp-ra-check]');
          if (!box) return;
          if (box.checked) s.checked[box.value] = true;
          else delete s.checked[box.value];
          update(formId);
        });
      }

      update(formId);
      scheduleUpdateAll();
    }
  }

  if (!window.customElements.get('mdp-routine-addons')) {
    window.customElements.define('mdp-routine-addons', RoutineAddons);
  }

  /* ---------------- Variant and quantity changes ---------------- */

  function formIdFromEvent(event) {
    var d = event.detail || {};
    if (d.formId) return d.formId;
    var t = event.target;
    return t && t.getAttribute ? t.getAttribute('id') : null;
  }

  document.addEventListener('variant:change', function (event) {
    var formId = formIdFromEvent(event);
    if (!formId || !state[formId]) {
      scheduleUpdateAll();
      setTimeout(updateAll, 50);
      setTimeout(updateAll, 400);
      return;
    }
    var v = event.detail && event.detail.variant;
    if (v) {
      state[formId].variant = { id: Number(v.id), price: Number(v.price), available: v.available !== false };
    } else {
      state[formId].variant = { id: null, price: 0, available: false };
    }
    update(formId);
    setTimeout(function () { update(formId); }, 350);
  });

  /* Any option, id or quantity change: the theme sets the form's id value right after, so re-read then. */
  document.addEventListener('change', function (event) {
    if (!Object.keys(state).length) return;
    setTimeout(updateAll, 0);
    setTimeout(updateAll, 150);
  });

  document.addEventListener('input', function (event) {
    var t = event.target;
    if (!t || t.name !== 'quantity') return;
    scheduleUpdateAll();
  });

  /* The theme can replace the buy button HTML (variant change, sold out state). Re-apply the total. */
  function observe() {
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function () {
      if (Object.keys(state).length) scheduleUpdateAll();
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  else observe();

  /* Programmatic id changes fire no event; a light poll keeps the total in sync (writes only on change). */
  window.addEventListener('load', updateAll);
  setInterval(function () {
    if (Object.keys(state).length && !document.hidden) updateAll();
  }, 600);

  /* ---------------- Add to cart ---------------- */

  function mainItem(form) {
    var item = { id: Number(fieldValue(form, 'id')), quantity: quantity(form) };
    var fd;
    try {
      fd = new FormData(form);
    } catch (e) {
      fd = null;
    }
    if (fd) {
      if (!item.id && fd.get('id')) item.id = Number(fd.get('id'));
      var plan = fd.get('selling_plan');
      if (plan) item.selling_plan = Number(plan) || plan;
      var props = {};
      var hasProps = false;
      fd.forEach(function (value, key) {
        var m = /^properties\[(.+)\]$/.exec(key);
        if (m && typeof value === 'string' && value !== '') {
          props[m[1]] = value;
          hasProps = true;
        }
      });
      if (hasProps) item.properties = props;
    }
    return item;
  }

  function submitButtons(form, extra) {
    var list = [];
    var fid = form && form.getAttribute ? form.getAttribute('id') : '';
    if (form && fid) {
      var own = form.querySelectorAll('[type="submit"]');
      var linked = document.querySelectorAll('[type="submit"][form="' + fid + '"]');
      for (var i = 0; i < own.length; i++) list.push(own[i]);
      for (var j = 0; j < linked.length; j++) list.push(linked[j]);
    }
    if (extra && list.indexOf(extra) === -1) list.push(extra);
    return list;
  }

  function setBusy(buttons, busy) {
    buttons.forEach(function (b) {
      if (busy) {
        b.setAttribute('aria-busy', 'true');
        b.__mdpWasDisabled = b.disabled;
        b.disabled = true;
      } else {
        b.removeAttribute('aria-busy');
        b.disabled = !!b.__mdpWasDisabled;
      }
    });
  }

  function showError(form, message) {
    if (!form) return;
    form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: message, description: message } }));
  }

  async function postAdd(items) {
    if (window.MDPCart && typeof window.MDPCart.add === 'function') {
      return window.MDPCart.add(items);
    }
    /* Fallback without the custom drawer script. */
    var res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    });
    var json = await res.json().catch(function () { return {}; });
    if (res.ok) document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    return { ok: res.ok, status: res.status, json: json };
  }

  var busyForms = {};

  async function addWithAddons(formId, submitter) {
    if (busyForms[formId]) return;
    var form = getForm(formId);
    if (!form) return;
    if (form.checkValidity && !form.checkValidity()) {
      if (form.reportValidity) form.reportValidity();
      return;
    }

    var main = mainItem(form);
    if (!main.id) return;
    var addons = checkedAddons(formId).filter(function (a) { return a.id !== main.id; });
    var items = [main].concat(addons.map(function (a) { return { id: a.id, quantity: 1 }; }));

    busyForms[formId] = true;
    var buttons = submitButtons(form, submitter);
    setBusy(buttons, true);

    try {
      var result = await postAdd(items);
      if (!result.ok && items.length > 1) {
        /* One of the add-ons could not be added (for example sold out): add the main product only. */
        result = await postAdd([main]);
        if (result.ok) {
          window.setTimeout(function () {
            showError(form, 'Een extra product is niet meer beschikbaar en is niet toegevoegd.');
          }, 600);
        }
      }

      if (!result.ok) {
        showError(form, (result.json && (result.json.description || result.json.message)) || 'Toevoegen lukt nu niet. Probeer het opnieuw.');
        return;
      }

      form.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true,
        detail: { items: (result.json && result.json.items) || items, cart: result.cart || null, mdp: true }
      }));

      /* The add-ons are in the cart now: reset the choices. */
      st(formId).checked = {};
      var els = addonElements(formId);
      for (var i = 0; i < els.length; i++) {
        var boxes = els[i].querySelectorAll('[data-mdp-ra-check]');
        for (var j = 0; j < boxes.length; j++) boxes[j].checked = false;
      }
      update(formId);

      var s = window.themeVariables && window.themeVariables.settings;
      if (s && s.cartType === 'page' && s.pageType !== 'cart') {
        window.location.href = root + 'cart';
      }
    } catch (e) {
      showError(form, 'Toevoegen lukt nu niet. Probeer het opnieuw.');
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } finally {
      busyForms[formId] = false;
      setBusy(buttons, false);
    }
  }

  function firstFormWithAddons() {
    var ids = Object.keys(state);
    for (var i = 0; i < ids.length; i++) {
      if (checkedAddons(ids[i]).length && getForm(ids[i])) return ids[i];
    }
    return null;
  }

  /* Capture phase on document: runs before the theme's own submit handler on the form. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;

    var formId = null;
    /* Note: form.id would return the <input name="id"> element on product forms, so read the attribute. */
    var ownId = form.getAttribute('id');
    if (ownId && state[ownId] && checkedAddons(ownId).length) {
      formId = ownId;
    } else if (form.closest && form.closest('#sticky_cus-atc-bar')) {
      formId = firstFormWithAddons();
    }
    if (!formId) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addWithAddons(formId, event.submitter || null);
  }, true);

  window.MDPRoutineAddons = { update: updateAll, checked: checkedAddons };
})();